import Confirm from "./Confirm";
import Device from "./Device";

export default {
  DEVICE: Device,
  CONFIRM: Confirm,
};
